<div class="message-pop-container" *ngIf="message">
  <div
    class="alert {{ message.status }} message-pop-alert d-flex align-items-center justify-content-between"
    role="alert"
  >
    <div>
      <strong *ngIf="message.subject">{{ message.subject }}</strong>
      <span>{{ message.message }}</span>
    </div>
    <button
      type="button"
      class="btn-close ms-3"
      aria-label="Close"
      (click)="close()"
    ></button>
  </div>
</div>
